import {
    Directive,
    Input,
    HostListener,
    Renderer2,
    ElementRef,
    Inject,
} from '@angular/core';
import { DefaultValueAccessor } from '@angular/forms';
import { EventEmitter } from 'events';
import { ILoggingService, LoggingService } from '../shared/services/logging/logging.service';

@Directive({
    selector: '[pDatatableEditor]',
    standalone: false
})
export class PTableEditorDirective extends DefaultValueAccessor {
    constructor(
        private log: LoggingService,
        _renderer: Renderer2,
        _elementRef: ElementRef,
    ) {
        super(_renderer, _elementRef, true);
    }
    @Input('pDatatableEditor') table: any;

    @HostListener('keydown', ['$event'])
    public onCellEditorKeydown(event: Event) {
        this.forwardEvent('onCellEditorKeydown', event);
    }

    @HostListener('input', ['$event'])
    public onCellEditorInput(event: Event) {
        this.forwardEvent('onCellEditorInput', event);
    }

    @HostListener('blur', ['$event'])
    public onCellEditorBlur(event: Event) {
        this.forwardEvent('onEditComplete', event);
    }

    @HostListener('change', ['$event'])
    public onCellEditorChange(event: Event) {
        this.forwardEvent('onEditComplete', event);
    }

    private forwardEvent(eventName: string, event: Event) {
        this.log.verbose({
            type: 'pDatatableEditor:forwardEvent',
            eventName,
            event,
        });
        let emitter: EventEmitter;
        emitter = this.table[eventName];

        if (emitter) {
            const evt: any = {
                field: this.table.editingCellField,
                data: this.table.editingCellData,
                originalEvent: event,
            };
            emitter.emit(evt);
        }
    }
}
